export default __webpack_public_path__ + "static/media/B0006.1e19f665.png";